// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"160":"8a326a62","290":"551f3c38","487":"46a3ad1f","513":"46a3ad1f"}[chunkId] + ".chunk.css";
};